import React, { useEffect } from 'react';
import { Link, Outlet, useLocation } from 'react-router-dom';
import styles from './style.module.scss';
import zlogo from '../../Images/logo_white.png';
import Logo from '../../Images/FanzpickLogo.png';
import Footer from '../Footer/Footer';
import appstore from '../../Images/appstore.png';
import googleplay from '../../Images/googlebtn.png';
function Layout() {
  const location = useLocation();

  const navigate = location.pathname;
  //  console.log("PathName::::", navigate);
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [navigate]);

  return (
    <div className={styles.layout}>
      <div className={styles.layout_left}>
        <Link to={'/'}>
          <img src={zlogo} alt='imgs' />
        </Link>
        <div>
          <img src={Logo} alt='Logo' />
        </div>
        {(navigate === '/about-us' ||
          navigate === '/privacy-policy' ||
          navigate === '/delete-account-policy' ||
          navigate === '/faq' ||
          navigate === '/support') &&
          window.innerWidth > 500 && (
            <div className={styles.buttons}>
              <Link
                to={'https://apps.apple.com/us/app/fanzpick/id6449597077'}
                target='_blank'
              >
                <img src={appstore} alt='imgs' />
              </Link>
              <Link
                to={
                  'https://play.google.com/store/apps/details?id=com.fanzpick&hl=en_IN'
                }
                target='_blank'
              >
                <img src={googleplay} alt='imgs' />
              </Link>
            </div>
          )}
      </div>
      <div className={styles.layout_right}>
        <Outlet />
        <Footer />
      </div>
    </div>
  );
}

export default Layout;
